import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import VesselOwnerSidebar from '../Vessel_Owner/VesselOwner/VesselOwnerSidebar';
import { IconButton } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';

const VesselOwnerLayouts = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div style={{ display: 'flex', position: 'relative' }}>
      {/* Toggle Button - Always visible */}
      <IconButton
        onClick={toggleSidebar}
        style={{
          position: 'fixed',
          top: '10px',
          left: sidebarOpen ? '270px' : '10px',
          backgroundColor: '#1976d2', // MUI primary color
          color: 'white',
          zIndex: 1500, // Higher than sidebar
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
          transition: 'left 0.3s ease-in-out',
        }}
      >
        <MenuIcon />
      </IconButton>

      {/* Fixed Sidebar with transition */}
      <div
        style={{
          width: '260px',
          height: '100vh',
          position: 'fixed',
          top: 0,
          left: sidebarOpen ? 0 : '-260px', // Move sidebar off-screen when closed
          background: '#f5f5f5',
          borderRight: '1px solid #ddd',
          overflowY: 'auto',
          overflowX: 'hidden',
          scrollbarWidth: 'none', 
          msOverflowStyle: 'none',
          transition: 'left 0.3s ease-in-out', // Smooth transition
          zIndex: 1000,
        }}
      >
        <VesselOwnerSidebar />
      </div>

      {/* Main Content Area that adjusts based on sidebar state */}
      <div
        style={{
          marginLeft: sidebarOpen ? '260px' : '0', // No margin when sidebar is closed
          width: sidebarOpen ? 'calc(100% - 260px)' : '100%', // Full width when sidebar is closed
          height: '100vh',
          overflowY: 'auto',
          overflowX: 'hidden',
          padding: '20px',
          boxSizing: 'border-box',
          transition: 'margin-left 0.3s ease-in-out, width 0.3s ease-in-out', // Smooth transition
        }}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default VesselOwnerLayouts;